import { atom } from 'recoil';

export const sidebarState = atom({
  key: 'sidebarState',
  default: true, // İlk yükleme için true
});